const GOOGLE_PLAY_APPS: Record<string, string> = {
    'bmg-ragdoll-car-race': 'https://play.google.com/store/apps/details?id=com.playgama.bmgragdollcarrace',
    'crazy-cart': 'https://play.google.com/store/apps/details?id=com.playgama.crazycart',
    'dress-up-3d': 'https://play.google.com/store/apps/details?id=com.playgama.dressup3d',
    'prison-architect-cage-break-tycoon': 'https://play.google.com/store/apps/details?id=com.playgama.prisonarchitect',
}

const GOOGLE_PLAY_EXPERIMENT_SAMPLE = 'gp-button'

export function getGooglePlayAppUrl({
    gameHru,
    experimentSample,
}: {
    gameHru: string | undefined
    experimentSample: string | undefined
}): string | undefined {
    if (experimentSample !== GOOGLE_PLAY_EXPERIMENT_SAMPLE) {
        return undefined
    }
    return gameHru ? GOOGLE_PLAY_APPS[gameHru] : undefined
}
